import Vue from 'vue';
import Vuex from 'vuex';
// MODULE IMPORTS

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		showContent: true,
		showSpinner: false
	},
	mutations: {
		SHOW_CONTENT (state) {
			state.showContent = true;
			state.showSpinner = false;
		},
		HIDE_CONTENT (state) {
			state.showContent = false;
			state.showSpinner = true;
		}
	},
	actions: {
		showContent (context) {
			context.commit('SHOW_CONTENT');
		},
		hideContent (context) {
			context.commit('HIDE_CONTENT');
		}
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js